import React, { useCallback } from 'react';
import { Field, useFormikContext } from 'formik';
import _ from 'lodash';
import { Country } from '@tradingblock/types';
import { TextboxField, SelectDropdownField } from './';
import { FormGroup } from '../../basic';

var formatedValue = function formatedValue(value) {
  return value ? value.toLowerCase().split(' ').map(function (word) {
    return word.charAt(0).toUpperCase() + word.substring(1);
  }).join(' ') : '';
}; // Function to get USPS response from storage


var getUspsResponseFromStorage = function getUspsResponseFromStorage(prefix) {
  var uspsResponseFromStorage = localStorage.getItem("".concat(prefix, ".uspsResponse"));
  return uspsResponseFromStorage && uspsResponseFromStorage !== 'undefined' ? uspsResponseFromStorage : null;
};

export var AddressField = function AddressField(_ref) {
  var id = _ref.id,
      labelPrefix = _ref.labelPrefix,
      countryProps = _ref.countryProps,
      addr1Help = _ref.addr1Help,
      stateProps = _ref.stateProps,
      field = _ref.field;
  var value = field.value;

  var country = _.get(value, "".concat(id, ".country"));

  var uspsResponse = getUspsResponseFromStorage(id);
  var context = useFormikContext();
  var uspsResponseValues, city, state, zip5, uspsAddress1, uspsAddress2;

  if (uspsResponse) {
    uspsResponseValues = JSON.parse(uspsResponse);
    city = formatedValue(uspsResponseValues.city);
    state = uspsResponseValues.state;
    zip5 = formatedValue(uspsResponseValues.zip5);
    uspsAddress1 = formatedValue(uspsResponseValues.uspsAddress1);
    uspsAddress2 = formatedValue(uspsResponseValues.uspsAddress2);
  }

  var getTextboxFieldProps = useCallback(function (field) {
    var fieldProps = {
      component: TextboxField,
      id: "".concat(id, ".").concat(field),
      defaultLabelId: "address.".concat(field)
    };

    if (field === 'state') {
      fieldProps.defaultLabelId = "address.province";
    }

    if (labelPrefix) {
      return Object.assign({}, fieldProps, {
        labelPrefix: labelPrefix
      });
    }

    return fieldProps;
  }, [id, labelPrefix]);

  var showUseProvidedButton = function showUseProvidedButton() {
    return context.errors && context.submitCount > 0 && (uspsAddress1 && context.errors["".concat(id, ".address1")] || uspsAddress2 && context.errors["".concat(id, ".address2")] || city && context.errors["".concat(id, ".city")] || state && context.errors["".concat(id, ".state")] || zip5 && context.errors["".concat(id, ".postalCode")]);
  };

  return React.createElement(React.Fragment, null, React.createElement(FormGroup, null, React.createElement(Field, Object.assign({
    component: SelectDropdownField,
    id: "".concat(id, ".country")
  }, countryProps, {
    autoComplete: "".concat(id, ".country")
  }))), React.createElement(FormGroup, {
    help: addr1Help
  }, React.createElement(Field, Object.assign({}, getTextboxFieldProps('address1')))), React.createElement(FormGroup, null, React.createElement(Field, Object.assign({}, getTextboxFieldProps('address2')))), React.createElement(FormGroup, null, React.createElement(Field, Object.assign({}, getTextboxFieldProps('city')))), React.createElement(FormGroup, null, (country === Country.UnitedStatesOfAmerica || country === '') && React.createElement(React.Fragment, null, React.createElement(Field, Object.assign({
    component: SelectDropdownField,
    id: "".concat(id, ".state")
  }, stateProps, {
    autoComplete: 'HEYOOOO'
  }))), country !== Country.UnitedStatesOfAmerica && country !== '' && React.createElement(React.Fragment, null, React.createElement(Field, Object.assign({}, getTextboxFieldProps('state'))))), React.createElement(FormGroup, null, React.createElement(Field, Object.assign({}, getTextboxFieldProps('postalCode')))), showUseProvidedButton() && React.createElement(FormGroup, null, React.createElement("button", {
    className: "btn btn-block btn-outline-dark",
    onClick: function onClick(e) {
      e.preventDefault();
      var updatedValues = context.values;
      var idSplit = id.split('.');
      if (uspsAddress1 && context.errors["".concat(id, ".address1")]) updatedValues[idSplit[0]][idSplit[1]]['address1'] = uspsAddress1;
      if (uspsAddress2 && context.errors["".concat(id, ".address2")]) updatedValues[idSplit[0]][idSplit[1]]['address2'] = uspsAddress2;
      if (city && context.errors["".concat(id, ".city")]) updatedValues[idSplit[0]][idSplit[1]]['city'] = city;
      if (state && context.errors["".concat(id, ".state")]) updatedValues[idSplit[0]][idSplit[1]]['state'] = state;
      if (zip5 && context.errors["".concat(id, ".postalCode")]) updatedValues[idSplit[0]][idSplit[1]]['postalCode'] = zip5;
      context.validateForm(updatedValues);
    }
  }, "Use provided")));
};